import { useActiveDataflowId } from "@/stores/dataflow";
import { useMapStore } from "@/stores/map";
import { logger } from "@/utils/debug";
import { Button, Group, Modal, Stack, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";

export function WorkspaceModalMapFolder({
  onClose,
  title = "Configure Folder",
  folderId,
  initialName,
}: {
  onClose: () => void;
  title?: string;
  folderId?: string;
  initialName?: string;
}) {
  const activeDataflowId = useActiveDataflowId();
  const setFolderName = useMapStore((state) => state.setFolderName);
  const getFolderName = useMapStore((state) => state.getFolderName);

  const currentName =
    activeDataflowId && folderId
      ? getFolderName(activeDataflowId, folderId)
      : undefined;

  const form = useForm<{
    name: string;
  }>({
    initialValues: {
      name: initialName || currentName || "",
    },
    validate: {
      name: (value) =>
        !value || value.trim() === "" ? "Name is required" : null,
    },
  });

  const handleSubmit = (values: { name: string }) => {
    if (!activeDataflowId || !folderId) {
      logger.error(
        "Cannot save folder name: missing activeDataflowId or folderId",
        {
          activeDataflowId,
          folderId,
        }
      );
      return;
    }

    setFolderName(activeDataflowId, folderId, values.name.trim());
    onClose();
  };

  return (
    <Modal
      opened={true}
      onClose={onClose}
      title={title}
      size="md"
      closeOnClickOutside={false}
      centered
    >
      <form
        onSubmit={form.onSubmit(handleSubmit, (errors) => {
          logger.error("Form validation errors:", errors);
        })}
      >
        <Stack gap="md">
          <TextInput
            label="Folder Name"
            placeholder="Enter folder name"
            {...form.getInputProps("name")}
            required
            error={form.errors.name}
          />

          <Group justify="flex-end" mt="md">
            <Button variant="subtle" type="button" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit">Save</Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
}
